module.exports = __webpack_public_path__ + "assets/images/vcr_cinema-02.8c9af9905f1169ca0b70f663a7a5581e.svg";